<form
	(ngSubmit)="searchByPin(searchByPinForm)"
	#searchByPinForm="ngForm"
	class="flex items-center rounded-xl"
	[@openCloseWithState]="showSearchSection ? 'open' : 'closed'"
	id="teranetForm"
>
	<div class="flex pb-2">
		<div class="flex">
			<app-input
				[(ngModel)]="pin"
				name="pin"
				[required]="true"
				[submitted]="submitted"
				pin-format
				label="Property identification number"
				[testHook]="testHooks.PropertyIdentificationNumber"
			></app-input>
		</div>
		<div class="flex items-end">
			<ui-button
				class="ml-5 mb-1"
				preset="HIGH_EMPHASIS"
				type="submit"
				teranetLoginGuard
				label="Search"
				[testHook]="testHooks.SearchButton"
			>
			</ui-button>
		</div>
	</div>
</form>

<app-pins-table
	[pins]="pins"
	[error]="error"
	[searching]="searchingPins"
	[isOverview]="isOverview"
	[name]="pin"
></app-pins-table>
